import api from "./apiBase";

function listSupplies(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`/supplies?${query}`);
}

function listSuppliesUsers(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`/supplies-users?${query}`);
}

function associateSuppliesUser(id, data) {
  return api.post("/supplies-users/" + id, data);
}

function updateSuppliesUserQuantity(id, data) {
  return api.patch("/supplies-users/" + id, data);
}

function removeSuppliesUser(id) {
  return api.delete("/supplies-users/" + id);
}

function requestSupplies(data) {
  return api.post("/supplies-requested", data);
}

export {
  listSupplies,
  listSuppliesUsers,
  associateSuppliesUser,
  updateSuppliesUserQuantity,
  removeSuppliesUser,
  requestSupplies,
}